var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMentionedinline = function SvgMentionedinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9A9AA1",
    d: "M9.357 16c1.036 0 2.2-.213 2.994-.458.325-.1.48-.451.373-.774a.696.696 0 0 0-.85-.438c-.633.174-1.548.37-2.442.37-3.848 0-5.911-2.037-5.911-5.68 0-3.491 2.04-5.747 5.7-5.747 3.343 0 5.338 2.064 5.333 4.852.005 2.382-.315 3.452-1.355 3.452-.589 0-.915-.461-.915-1.038V6.15a.703.703 0 0 0-.703-.703h-.088a.615.615 0 0 0-.615.615h-.074c-.172-.483-1.167-.916-2.361-.78-1.652.187-3.07 1.5-3.07 3.661 0 2.256 1.2 3.765 3.127 3.836 1.303.055 2.15-.526 2.418-1.174h.069c.137.884 1.131 1.273 2.109 1.24C15.537 12.801 16 10.496 16 8.18 16 4.876 13.645 2 9.277 2 4.698 2 2.006 4.684 2 9.008 2.006 13.46 4.63 16 9.357 16m-.526-4.566c-1.492 0-2.006-1.23-2.012-2.557.006-1.263.743-2.267 2.035-2.267 1.4 0 2.03.593 2.035 2.261.006 1.712-.571 2.563-2.058 2.563"
  })));
};
export default SvgMentionedinline;